import PendingAdjustmentDetailsPage from './PendingAdjustmentDetailsPage'

export default PendingAdjustmentDetailsPage
